import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { parseDate } from '@eb/datetime';

export default class DateThumbnail extends PureComponent {
    static propTypes = {
        /**
         * Date to be displayed as thumbnail
         */
        date: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.instanceOf(Date),
            PropTypes.object,
        ]),
    };

    render() {
        const { date } = this.props;

        let component = null;

        if (date) {
            const { day, month } = parseDate(date);

            component = (
                <div className="date-thumbnail eds-text--center eds-l-mar-top-1">
                    <p
                        className="date-thumbnail__month eds-text-color--primary-brand eds-text-bs"
                        data-spec="date-thumbnail-month"
                    >
                        {month.toUpperCase()}
                    </p>
                    <p
                        className="date-thumbnail__day eds-text-bl eds-text-color--ui-600"
                        data-spec="date-thumbnail-day"
                    >
                        {day}
                    </p>
                </div>
            );
        }

        return component;
    }
}
